import React, { useEffect, useState } from "react";
import ReactModal from 'react-modal';

import axios from "axios";

import Validate from '../../../helpers/validate';
import authHeader from '../../../services/auth-header';
import { TextControl, SelectControl } from '../Controls';
import DocumentManager from "../DocumentManager";

function EditVehicleModal(props) {

    const [vehicleInsurance, setVehicleInsurance] = useState('');
    const [vehicleEmissionTest, setVehicleEmissionTest] = useState('');
    const [vehiclePlates, setVehiclePlates] = useState('');
    const [vehicleRegistration, setVehicleRegistration] = useState('');
    const [vehicleColor, setVehicleColor] = useState('');
    const [vehicleCab, setVehicleCab] = useState('');
    const [plateExpiration, setPlateExpiration] = useState('');
    const [errorMessage, setErrorMessage] = useState({});

    useEffect(() => {
        if (props.isOpen) {
            setVehicleInsurance(props.vehicle.vehicleInsuranceData || '');
            setVehicleEmissionTest(props.vehicle.vehicleEmissionTest || '');
            setVehiclePlates(props.vehicle.vehiclePlates || '');
            setVehicleRegistration(props.vehicle.vehicleRegistration || '');
            setVehicleColor(props.vehicle.color || '');
            setVehicleCab(props.vehicle.cab || '');

            if (props.vehicle.plateExpiration) {
                const plateExpirationDate = new Date(props.vehicle.plateExpiration);
                setPlateExpiration(plateExpirationDate.toISOString().substring(0, 10));
            }
        }
    }, [props.isOpen]);

    async function handleSubmit() {
        const validate = new Validate();
        const message = {};
        message.vehicleEmissionTest = validate.init(vehicleEmissionTest, {
            maxLength: {
                value: 150,
                message: 'The maximum length possible of the first name is 150 characters'
            },
            minLength: {
                value: 1,
                message: 'The minimum length possible of the first name is 1 character'
            }
        }).getHTML();
        message.vehiclePlates = validate.init(vehiclePlates, {
            maxLength: {
                value: 150,
                message: 'The maximum length possible of the first name is 150 characters'
            },
            minLength: {
                value: 1,
                message: 'The minimum length possible of the first name is 1 character'
            }
        }).getHTML();
        message.vehicleRegistration = validate.init(vehicleRegistration, {
            maxLength: {
                value: 150,
                message: 'The maximum length possible of the first name is 150 characters'
            },
            minLength: {
                value: 1,
                message: 'The minimum length possible of the first name is 1 character'
            }
        }).getHTML();
        message.vehicleColor = validate.init(vehicleColor, {
            maxLength: {
                value: 20,
                message: 'The maximum length possible of the first name is 20 characters'
            },
            minLength: {
                value: 1,
                message: 'The minimum length possible of the first name is 1 character'
            }
        }).getHTML();
        message.vehicleCab = validate.init(vehicleCab, {
            maxLength: {
                value: 3,
                message: 'The maximum length possible of the first name is 3 characters'
            },
            minLength: {
                value: 1,
                message: 'The minimum length possible of the first name is 1 character'
            },
            integer: {
                message: 'The vehicle cab can only be a only be a number'
            }
        }).getHTML();
        message.vehicleInsurance = validate.init(vehicleInsurance, {
            maxLength: {
                value: 150,
                message: 'The maximum length possible of the first name is 150 characters'
            },
            minLength: {
                value: 1,
                message: 'The minimum length possible of the first name is 1 character'
            }
        }).getHTML();
        message.plateExpiration = validate.init(plateExpiration, {
            notEmpty: {
                message: 'A plate expiration date must be selected'
            }
        }).getHTML();
        setErrorMessage(message);

        const plateExpirationDate = parseDate(plateExpiration);

        if (validate.status) {
            const plateExpirationDateStr = plateExpirationDate.toISOString().substr(0, 10);

            props.vehicle.vehicleInsuranceData = vehicleInsurance;
            props.vehicle.vehicleEmissionTest = vehicleEmissionTest;
            props.vehicle.vehicleRegistration = vehicleRegistration;
            props.vehicle.vehiclePlates = vehiclePlates;
            props.vehicle.color = vehicleColor;
            props.vehicle.color = vehicleColor;
            props.vehicle.cab = vehicleCab;
            props.vehicle.plateExpiration = plateExpirationDateStr;
            try {
                await axios.put(process.env.REACT_APP_API_URL + `api/admin/updateVehicle/${props.vehicle.vehicleId}`, {
                    vehicleInsuranceData: vehicleInsurance, vehicleEmissionTest,
                    vehicleRegistration, vehiclePlates,
                    color: vehicleColor, cab: vehicleCab,
                    plateExpiration: plateExpirationDateStr
                }, {
                    headers: authHeader()
                });
                props.onClose();
                props.updateTable();
            }
            catch (error) {
                props.onClose();
                props.updateTable();
            }
        }
    }

    function handleFocus(event) {
        const element = event.target.id,
            messages = errorMessage;
        messages[element] = null;
        setErrorMessage(messages);
    }

    function parseDate(value) {
        const b = value.split(/\D/);
        return new Date(b[0], --b[1], b[2]);
    }

    function clearControls() {
        setVehicleInsurance('');
        setVehicleEmissionTest('');
        setVehiclePlates('');
        setVehicleRegistration('');
        setVehicleColor('');
        setVehicleCab('');
        setPlateExpiration('');
        setErrorMessage({});
    }

    return (
        <ReactModal isOpen={props.isOpen} style={{ overlay: { zIndex: '999' } }}>
            <div className="container">
                <div className="row">
                    <div className="col s11 left hide-on-small-only" style={{ fontVariant: 'small-caps', fontFamily: 'Raleway', fontSize: '2rem' }}>
                        Edit Vehicle
                    </div>
                    <div className="col s1 right">
                        <a onClick={() => {
                            clearControls();
                            props.onClose();
                        }} className="btn-floating waves-effect waves-light black white-text"><i className="material-icons">close</i></a>
                    </div>
                </div>
                <hr />
                <CustomRow>
                    <div className="input-field col s8">
                        <TextControl id="vehicleInsurance" name="vehicleInsurance" value={vehicleInsurance} inputEventHandler={setVehicleInsurance} focusEventHandler={handleFocus} maxlength="150" />
                        <label className="active" htmlFor="vehicleInsurance">Vehicle Insurance</label>
                        <span data-assigned="vehicleInsurance" className="helper-text red-text text-darken-1">{errorMessage.vehicleInsurance}</span>
                    </div>
                </CustomRow>
                <CustomRow>
                    <div className="input-field col s8">
                        <TextControl id="vehicleEmissionTest" name="vehicleEmissionTest" value={vehicleEmissionTest} inputEventHandler={setVehicleEmissionTest} focusEventHandler={handleFocus} maxlength="150" />
                        <label className="active" htmlFor="vehicleEmissionTest">Vehicle Emission Test</label>
                        <span data-assigned="vehicleEmissionTest" className="helper-text red-text text-darken-1">{errorMessage.vehicleEmissionTest}</span>
                    </div>
                </CustomRow>
                <CustomRow>
                    <div className="input-field col s8">
                        <TextControl id="vehiclePlates" name="vehiclePlates" value={vehiclePlates} inputEventHandler={setVehiclePlates} focusEventHandler={handleFocus} maxlength="150" />
                        <label className="active" htmlFor="vehiclePlates">Vehicle Plates</label>
                        <span data-assigned="vehiclePlates" className="helper-text red-text text-darken-1">{errorMessage.vehiclePlates}</span>
                    </div>
                </CustomRow>
                <CustomRow>
                    <div className="input-field col s8">
                        <input value={plateExpiration} onChange={(event) => setPlateExpiration(event.target.value)} type="date" id="plateExpiration" name="plateExpiration" />
                        <label htmlFor="plateExpiration">Plate Expiration Date</label>
                        <span data-assigned="plateExpiration" className="helper-text red-text text-darken-1">{errorMessage.plateExpiration}</span>
                    </div>
                </CustomRow>
                <CustomRow>
                    <div className="input-field col s8">
                        <TextControl id="vehicleRegistration" name="vehicleRegistration" value={vehicleRegistration} inputEventHandler={setVehicleRegistration} focusEventHandler={handleFocus} maxlength="150" />
                        <label className="active" htmlFor="vehicleRegistration">Vehicle Registration</label>
                        <span data-assigned="vehicleRegistration" className="helper-text red-text text-darken-1">{errorMessage.vehicleRegistration}</span>
                    </div>
                </CustomRow>
                <CustomRow>
                    <div className="input-field col s8">
                        <TextControl id="vehicleColor" name="vehicleColor" value={vehicleColor} inputEventHandler={setVehicleColor} focusEventHandler={handleFocus} maxlength="20" />
                        <label className="active" htmlFor="vehicleColor">Vehicle Color</label>
                        <span data-assigned="vehicleColor" className="helper-text red-text text-darken-1">{errorMessage.vehicleColor}</span>
                    </div>
                </CustomRow>
                <CustomRow>
                    <div className="input-field col s8">
                        <TextControl id="vehicleCab" name="vehicleCab" value={vehicleCab} inputEventHandler={setVehicleCab} focusEventHandler={handleFocus} maxlength="3" />
                        <label className="active" htmlFor="vehicleCab">Vehicle Cab</label>
                        <span data-assigned="vehicleCab" className="helper-text red-text text-darken-1">{errorMessage.vehicleCab}</span>
                    </div>
                </CustomRow>
                <CustomRow>
                    <div className="input-field col s8">
                        <a onClick={handleSubmit} style={{ width: '100%', fontFamily: 'Raleway', fontSize: '1rem', backgroundColor: 'black', marginTop: '30px' }} className="waves-effect waves-light btn z-depth-0 white-text">SAVE & CLOSE</a>
                    </div>
                </CustomRow>
                <DocumentManager id={`vehicle-${props.vehicle.vehicleId}`} driverId={props.vehicle.vehicleId} />
            </div>
        </ReactModal>
    );
}

function CustomRow(props) {
    return (
        <div className={`row ${props.className}`}>
            <div className="col s2"></div>
            {props.children}
            <div className="col s2"></div>
        </div>
    );
}

export default EditVehicleModal;